import { useSelector } from "react-redux";

import { getUser } from "../../ducks/user";
import { useProfilePhoto } from "../useProfilePhoto";

export const useUser = () => {
  const user = useSelector(getUser);

  useProfilePhoto(user?.username);

  return user;
};
